import { useMemo } from "react";
import { object, string, array } from "yup";
import { REGEXP, STRING_MAX_LENGTH } from "consts/validation";
import { FormField } from "./types";

export default function useValidationSchema() {
    return useMemo(() =>
        object().shape({
            [FormField.EndToEndIdSlug]: string()
                .max(32)
                .nullable()
                .label('End to End ID Slug'),

            [FormField.Name]: string()
                .max(STRING_MAX_LENGTH)
                .required()
                .label('Name'),

            [FormField.AddressType]: object()
                .required()
                .label('Address Type'),

            [FormField.Department]: string()
                .max(STRING_MAX_LENGTH)
                .required()
                .label('Department'),

            [FormField.SubDepartment]: string()
                .max(STRING_MAX_LENGTH)
                .required()
                .label('Sub Department'),

            [FormField.StreetName]: string()
                .max(STRING_MAX_LENGTH)
                .required()
                .label('Street Name'),

            [FormField.BuildingNumber]: string()
                .max(12)
                .required()
                .label('Building Number'),

            [FormField.PostCode]: string()
                .max(STRING_MAX_LENGTH)
                .required()
                .label('Post Code'),

            [FormField.TownName]: string()
                .max(STRING_MAX_LENGTH)
                .required()
                .label('Town Name'),

            [FormField.Country]: array()
                .of(string())
                .min(1)
                .required()
                .label('Country'),

            [FormField.CountrySubdivision]: string()
                .max(STRING_MAX_LENGTH)
                .required()
                .label('Country Subdivision'),

            [FormField.IbanAccount]: string()
                .max(32)
                .matches(REGEXP.IBAN, 'Invalid IBAN format')
                .uppercase()
                .required()
                .label('IBAN Account'),

            [FormField.BbanAccount]: string()
                .max(24)
                .required()
                .label('BBAN Account'),

            [FormField.AgentBicFi]: string()
                .max(24)
                .required()
                .label('Agent BIC FI'),

            [FormField.ClearingMemberId]: string()
                .max(STRING_MAX_LENGTH),

            [FormField.AccountCurrency]: string()
                .max(3)
                .required()
                .label('Account Currency')
        })
        , []);
};
